class ImageSwitcher extends HTMLElement {
  constructor() {
    super();
    this.isLipPage = window.location.href.includes("collections/lip");
    this.current_view_desktop_t = this.querySelector(
      "label.current-view-desktop"
    ).textContent;
    this.current_view_mobile_t = this.querySelector(
      "label.current-view-mobile"
    ).textContent;
    this.product_images_t = this.querySelector(
      "label.product-images"
    ).textContent;
  }

  connectedCallback() {
    this.switchLabelDesktop = this.querySelector(".switch-label.desktop");
    this.switchLabelMobile = this.querySelector(".switch-label.mobile");
    this.switchInput = this.querySelector("#view-switch");

    this.switchInput.addEventListener(
      "change",
      this.handleSwitchChange.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.switchInput) {
      this.switchInput.removeEventListener(
        "change",
        this.handleSwitchChange.bind(this)
      );
    }
  }

  handleSwitchChange() {
    if (this.switchInput.checked) {
      this.switchLabelDesktop.textContent = this.isLipPage
        ? `${this.current_view_desktop_t} Lippen`
        : `${this.current_view_desktop_t} Auge`;
      this.switchLabelMobile.textContent = this.isLipPage
        ? `${this.current_view_mobile_t} Lippen`
        : `${this.current_view_mobile_t} Auge`;
    } else {
      this.switchLabelDesktop.textContent = `${this.current_view_desktop_t} ${this.product_images_t}`;
      this.switchLabelMobile.textContent = `${this.current_view_mobile_t} ${this.product_images_t}`;
    }
    this.swapClassNames();
  }

  swapClassNames() {
    let hoverImages = document.querySelectorAll(".product-card--hover-image");
    let images = document.querySelectorAll(".product-card--image");

    hoverImages.forEach(function (element) {
      element.classList.remove("product-card--hover-image");
      element.classList.add("product-card--image-temp");
    });

    images.forEach(function (element) {
      element.classList.remove("product-card--image");
      element.classList.add("product-card--hover-image");
    });

    let tempImages = document.querySelectorAll(".product-card--image-temp");
    tempImages.forEach(function (element) {
      element.classList.remove("product-card--image-temp");
      element.classList.add("product-card--image");
    });
  }
}

customElements.define("image-switcher", ImageSwitcher);
